<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick" type="card" class="w-70">
        <el-tab-pane label="修改密码" name="first" class="oneTab">
          <span class="title">密码类型:</span>
          <muserPtypeSelect @setPtype="onPtypeChangeSelect"></muserPtypeSelect>
        </el-tab-pane>
        <el-tab-pane label="修改/绑定手机号" name="second" class="oneTab">
          <span class="title">手机号:</span>
          <el-input v-model="phone" placeholder="请输入手机号(选填)" type="number" class="phone_input"></el-input>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="form_box__main_box__input_group mt-2">
      <el-button style="margin-top: 12px;" type="primary" @click="save">更新</el-button>
    </el-card>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { muserEditPasswordApi, muserEditPhoneApi, muserEditInitApi } from "@/api/module/muser/muser";
import Base64 from "js-base64";
import { muserPtypeSelect } from "@/views/module/muser/component/index";

export default {
  name: "MuserAdd",
  
  mixins: [BaseVue],
  
  components: {
    muserPtypeSelect
  },
  
  data() {
    return {
      loading: false,
      ptype: "0", // 密码类型
      password: "",
      rpassword: "", // 校验密码
      id: "",
      activeName: "first", // 导航默认选中第一个
      phone: "" // 手机号
    };
  },
  
  methods: {
    // 导航切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    
    // 获取密码相关信息
    onPtypeChangeSelect(e) {
      console.log(123, e);
      this.password = e.password;
      this.rpassword = e.rpassword;
      this.ptype = e.ptype;
    },
    
    save() {
      if (this.activeName == "first") {
        if (this.ptype == 1) {
          if (this.password.length <= 0) {
            this.$message.error("请填写密码！");
            this.loading = false;
            return false;
          }
          if (this.password != this.rpassword) {
            this.$message.error("两次密码不一致！");
            this.loading = false;
            return false;
          }
        }
        this.loading = true;
        let ptype = this.ptype;
        let p = Base64.Base64.encode(this.password); // 加密后的密码
        let id = this.id;
        let data = {
          ptype,
          p,
          id
        };
        muserEditPasswordApi(data)
          .then(response => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/dashboard"
              });
            }, 1500);
          })
          .finally(() => {
            this.loading = false;
          });
      }
      if (this.activeName == "second") {
        if (!/^1[3456789]\d{9}$/.test(this.phone) && this.phone) {
          this.$message.error("手机号码有误，请重填！");
          return false;
        }
        this.loading = true;
        let data = {
          id: this.id,
          phone: this.phone
        };
        muserEditPhoneApi(data)
          .then(res => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            setTimeout(() => {
              this.$router.replace({
                path: "/dashboard"
              });
            }, 1500);
          })
          .catch(err => {
            return false;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  
  created() {
    this.id = this.$route.query.id;
    
    muserEditInitApi(this.id)
      .then(response => {
        this.phone = response.phone;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
.oneTab {
  display: flex;
  align-items: center;
}
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  box-sizing: border-box;
  white-space: nowrap;
  margin-right: 50px;
}
.oneTab ::v-deep .el-tabs__nav-wrap::after {
  background: none;
}
.phone_input {
  width: 200px;
  & ::v-deep input::-webkit-outer-spin-button,
  & ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  & ::v-deep input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>

